/**
 * White-label branding for the chromeless "clear" flow.
 *
 * The clear flow is presented as its own product, so nothing inside it may carry
 * Blueticks branding — name, logo, illustration, tab title or favicon. Everything
 * brand-facing in that flow resolves through this module, so renaming the product
 * again is a one-file change.
 *
 * Translated copy is handled separately and generically: an i18next post-processor
 * (see i18next.config.ts) swaps the literal "Blueticks" for CLEAR_BRAND_NAME while
 * the clear flow is active, which covers all ~40 strings in every locale without
 * forking the translation files.
 */
import { isClearFlow } from '@common/utils/clear-flow';

/** The product name shown inside the clear flow. */
export const CLEAR_BRAND_NAME = 'Whats148';

/** The product name everywhere else. Also the literal replaced in translated copy. */
export const DEFAULT_BRAND_NAME = 'Blueticks';

export const CLEAR_BRAND_LOGO = '/img/whats148-logo.svg';
export const CLEAR_BRAND_LOGIN_ILLUSTRATION = '/img/whats148-login.svg';
export const CLEAR_BRAND_SIGNUP_ILLUSTRATION = '/img/whats148-signup.svg';
export const CLEAR_BRAND_FAVICON = '/img/whats148-favicon.svg';

/**
 * MUI palette primary for the clear flow.
 *
 * MUI controls (Switch, Checkbox, Radio, Slider) colour themselves from the JS
 * theme, not from CSS custom properties, so the token override in
 * globals-website.css cannot reach them. BTThemeProvider swaps these in off the
 * same `data-clear-flow` attribute, keeping both systems on one signal.
 */
export const CLEAR_BRAND_PRIMARY = '#6366F1';
export const CLEAR_BRAND_PRIMARY_DARK = '#A78BFA';

/** The product name for the current flow. */
export const brandName = (pathname?: string): string =>
  isClearFlow(pathname) ? CLEAR_BRAND_NAME : DEFAULT_BRAND_NAME;
